// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"667":"dc2d895a","977":"593233f8"}[chunkId] + ".chunk.js");